var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45.67,
    height: 45.6684,
    rx: 17,
    fill: "#CCCCCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6129 24.8031C14.216 24.4219 14.0108 23.9149 14.0004 23.4044C13.9902 22.894 14.1749 22.3789 14.5559 21.982C14.9366 21.5854 15.4437 21.38 15.954 21.3698C16.4647 21.3593 16.9795 21.5434 17.3767 21.9249L20.8059 25.2246L27.6333 16.5518L27.8779 16.7384L27.6331 16.551C27.6526 16.5256 27.6747 16.5041 27.6993 16.4865C28.1055 16.1347 28.6153 15.9758 29.1137 16.003V16.0024L29.138 16.0046C29.6393 16.0378 30.1289 16.2606 30.4904 16.664C30.8581 17.0742 31.0248 17.5952 30.997 18.1045H30.9976L30.9954 18.1288C30.9627 18.6211 30.7476 19.1021 30.3577 19.4614L22.1641 29.435L22.1647 29.4356C22.1493 29.4551 22.132 29.4718 22.1132 29.4865C21.7296 29.8234 21.2451 29.9885 20.7633 29.9802C20.2776 29.9718 19.7928 29.7871 19.4157 29.4246L14.6129 24.8031Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.fa4b0fc8384015d1040209554bc20cf9.svg";
export { ForwardRef as ReactComponent };